import { evaluate } from 'eval-estree-expression';
const { parseExpression } = require('@babel/parser');

export function shouldSkipQuestion(question, answers) {
  if (typeof question?.condition === 'undefined' || question?.condition === null || question.condition === 'undefined') return false;
  const result = evaluate.sync(parseExpression(question.condition.replaceAll('numb(', 'Number(')), { ...answers, Number }, { functions: true  });

  return !result
}

export function getPreviousNonSkipQuestionNumber(questions, answers, questionNumber) {
  // Start on previous question
  let questionIndex = questionNumber - 2;
  while (questionIndex < questions.length) {
    const question = questions[questionIndex];
    if (!shouldSkipQuestion(question, answers)) break;
    // Go up till we find a question we should not skip
    questionIndex -= 1;
  }
  // +1 in questionIndex for questionNumber
  return questionIndex + 1;
}

export function getAnswerCount(answers) {
  const clonedAnswers = Object.assign({}, answers)
  delete clonedAnswers.update_scan_question_number

  return Object.values(clonedAnswers).length
}

export function getQuestionCountAfterConditions(questions, answers) {
    let count = 0;
    for (const question of questions) {
        if (!shouldSkipQuestion(question, answers)) {
            count++
        }
    }
    return count;
}

export function getFirstNonSkipQuestionNumber(questions, answers, questionNumber) {
  // if (answers.update_scan_question_number !== undefined) {
  //   return answers.update_scan_question_number + 1;
  // }
  // Start on current question
  let questionIndex = questionNumber - 1;
  while (questionIndex < questions.length) {
    const question = questions[questionIndex];
    if (!shouldSkipQuestion(question, answers)) break;
    // Go down till we find a question we should not skip
    questionIndex += 1;
  }
  // +1 in questionIndex for questionNumber
  return questionIndex + 1;
}

export function getFirstUnansweredQuestionNumber(questions, answers) {
  console.log('IN getFirstUnansweredQuestionNumber', {questions, answers})
  if (answers.update_scan_question_number !== undefined && answers.update_scan_question_number !== false) {
    return answers.update_scan_question_number + 1;
  }
  let questionNumber = 1;
  for (const question of questions) {
    if (
        question.key in answers
        || shouldSkipQuestion(question, answers)
    ) {
      questionNumber += 1;
    } else {
      break;
    }
  }
  return questionNumber;
}
